import React from 'react'
import Friends from '../friends/Friends'
import BestVideo from '../bestvideo/BestVideo'
import Credit from '../credit/Credit'
import './store.css'

const Store = () => {

      return (
            <div className="wrapper_store aside">
                  <Friends /> 
                  <BestVideo />
                  <Credit />
            </div>
      )
}

export default Store
